(() => {
  const cleanups = new WeakMap();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  function revealWithin(root) {
    root.closest?.('.lfx-reveal')?.classList.add('is-visible');
    root.querySelectorAll('.lfx-reveal').forEach(node => node.classList.add('is-visible'));
  }
  function init(root = document) {
    root.querySelectorAll('.lfx-flip[data-lfx-flip]').forEach(card => {
      if(card.dataset.ready) return;
      card.dataset.ready = 'true';
      const button = card.querySelector('button');
      const front = card.querySelector('.lfx-flip-front');
      const back = card.querySelector('.lfx-flip-back');
      const toggle = () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        card.classList.toggle('is-flipped', open);
        front.setAttribute('aria-hidden', String(open));
        back.setAttribute('aria-hidden', String(!open));
      };
      button.addEventListener('click', toggle);
      cleanups.set(card, () => button.removeEventListener('click', toggle));
    });
    root.querySelectorAll('.lfx:not(.lfx-ticker):not(.lfx-promotion), .lf-choose').forEach(section => {
      if(section.dataset.motionReady || !('IntersectionObserver' in window)) return;
      section.dataset.motionReady = 'true';
      const targets = [...section.querySelectorAll('.lfx-heading, .lfx-intro, .lfx-flip, .lfx-icon-grid article, .lfx-product-orbit, .lfx-comparison-table, .lfx-comparison-copy, .lfx-trust-card, .lfx-track, .lfx-pointer-area, .lfx-accordions, .lfx-tab-buttons, .lfx-guarantee-image, .rr-stat-block, .rr-cta-area')];
      if(!targets.length && section.firstElementChild) targets.push(section.firstElementChild);
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if(entry.isIntersecting) {entry.target.classList.add('is-visible');observer.unobserve(entry.target);}
      }), {threshold: 0, rootMargin: '0px 0px -24px 0px'});
      targets.forEach((node, index) => {
        node.classList.add('lfx-reveal');
        node.style.setProperty('--lfx-delay', `${Math.min(index % 4, 3) * 65}ms`);
        if(motion.matches || node.getBoundingClientRect().top < innerHeight - 24) node.classList.add('is-visible');
        else observer.observe(node);
      });
      const show = () => {if(motion.matches) revealWithin(section);};
      motion.addEventListener('change', show);
      section._lfxMotionCleanup = () => {observer.disconnect();motion.removeEventListener('change', show);};
    });
    root.querySelectorAll('[data-lfx-slider]').forEach(slider => {
      if(slider.dataset.ready) return; slider.dataset.ready='true';
      const track=slider.querySelector('[data-lfx-track]'), dots=[...slider.querySelectorAll('[data-lfx-dot]')], prev=slider.querySelector('[data-lfx-prev]'), next=slider.querySelector('[data-lfx-next]');
      const go=i=>{const card=track.children[i];if(card)track.scrollTo({left:card.offsetLeft-track.firstElementChild.offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
      const current=()=>Math.round(track.scrollLeft/((track.firstElementChild?.getBoundingClientRect().width||1)+parseFloat(getComputedStyle(track).gap||0)));
      const sync=()=>{dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===current())));prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
      prev.addEventListener('click',()=>go(current()-1));next.addEventListener('click',()=>go(current()+1));dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));track.addEventListener('scroll',sync,{passive:true});const observer=new ResizeObserver(sync);observer.observe(track);cleanups.set(slider,()=>observer.disconnect());sync();
    });
    root.querySelectorAll('[data-lfx-tabs]').forEach(tabs=>{
      if(tabs.dataset.ready)return;tabs.dataset.ready='true';const buttons=[...tabs.querySelectorAll('[role=tab]')],panels=[...tabs.querySelectorAll('[role=tabpanel]')];
      const select=index=>{buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});};
      buttons.forEach((b,i)=>{b.addEventListener('click',()=>select(i));b.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%buttons.length;else if(e.key==='ArrowLeft')n=(i-1+buttons.length)%buttons.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=buttons.length-1;else return;e.preventDefault();select(n);buttons[n].focus();});});
    });
    root.querySelectorAll('.lfx-timeline-list').forEach(list=>{
      if(list.dataset.ready)return;list.dataset.ready='true';
      const stages=[...list.querySelectorAll('[data-lfx-stage]')];
      let frame=0;
      const sync=()=>{
        frame=0;
        const threshold=innerHeight*.7;
        // Read geometry first, then write styles to avoid layout thrashing.
        const positions=stages.map(stage=>{
          const marker=stage.querySelector('.lfx-stage-marker').getBoundingClientRect();
          const line=stage.querySelector('.lfx-stage-line').getBoundingClientRect();
          const center=marker.top+marker.height/2;
          return {stage,active:center<=threshold,point:Math.max(0,Math.min(1,(threshold-center+32)/64)),line:Math.max(0,Math.min(1,(threshold-line.top)/Math.max(1,line.height)))};
        });
        positions.forEach(({stage,active,point,line})=>{
          stage.classList.toggle('is-active',active);
          stage.style.setProperty('--stage-point',point.toFixed(3));
          stage.style.setProperty('--stage-color',`${(point*100).toFixed(1)}%`);
          stage.style.setProperty('--stage-line',line.toFixed(3));
        });
      };
      const schedule=()=>{if(!frame)frame=requestAnimationFrame(sync);};
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule);
      const resize=new ResizeObserver(schedule);resize.observe(list);
      sync();cleanups.set(list,()=>{window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);resize.disconnect();cancelAnimationFrame(frame);});
    });
    root.querySelectorAll('[data-lfx-countdown]').forEach(timer=>{
      if(timer.dataset.ready)return;timer.dataset.ready='true';
      const demo = timer.dataset.lfxDemo === 'true' && window.Shopify?.designMode;
      const loop = timer.dataset.lfxLoop === 'true';
      const duration = Math.max(3600,Number(timer.dataset.lfxDuration || 7200))*1000;
      const storageKey = 'lfx-countdown-end-'+(timer.dataset.lfxTimerKey || 'promotion');
      const readSavedEnd=()=>{try{return Number(localStorage.getItem(storageKey));}catch(error){return 0;}};
      const saveEnd=value=>{try{localStorage.setItem(storageKey,String(value));}catch(error){}}
      let end = demo ? Date.now()+7200000 : Date.parse(timer.dataset.lfxCountdown);
      if(loop){
        const savedEnd=readSavedEnd();
        end=Number.isFinite(savedEnd)&&savedEnd>Date.now()?savedEnd:Date.now()+duration;
        saveEnd(end);
      }
      if(!Number.isFinite(end)){timer.hidden=true;return;}
      let interval;
      const tick=()=>{
        const now=Date.now();
        if(loop&&end<=now){end+=Math.max(1,Math.floor((now-end)/duration)+1)*duration;saveEnd(end);}
        const total=Math.max(0,Math.floor((end-now)/1000)), days=Math.floor(total/86400);
        ['days','hours','minutes','seconds'].forEach((key,i)=>{
          const value=[days,Math.floor(total/3600)%24,Math.floor(total/60)%60,total%60][i];
          const digit=timer.querySelector('[data-'+key+']');
          if(digit)digit.textContent=String(value).padStart(2,'0');
        });
        timer.querySelectorAll('[data-day-block],[data-day-separator]').forEach(node=>node.hidden=days===0);
        timer.hidden=!loop&&total===0;
        if(!loop&&total===0&&interval)clearInterval(interval);
      };
      tick();if(loop||end>Date.now())interval=setInterval(tick,1000);
      cleanups.set(timer,()=>clearInterval(interval));
    });
  }
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:select',e=>revealWithin(e.target));
  document.addEventListener('shopify:block:select',e=>revealWithin(e.target));
  document.addEventListener('focusin',e=>revealWithin(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-motion-ready]').forEach(n=>n._lfxMotionCleanup?.()));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-ready]').forEach(n=>cleanups.get(n)?.()));
  document.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[role=tabpanel]');if(panel){const tabs=panel.closest('[data-lfx-tabs]');tabs?.querySelector('[aria-controls="'+panel.id+'"]')?.click();}const card=e.target.closest('.lfx-benefit');if(card){const track=card.parentElement;track.scrollTo({left:card.offsetLeft-track.firstElementChild.offsetLeft,behavior:'instant'});}if(e.target.matches('details'))e.target.open=true;});
})();
